import { CSS } from "@dnd-kit/utilities";
import { useSortable } from "@dnd-kit/sortable";
import { ArrowDown, ArrowUp, ArrowUpDown, GripVertical, X } from "lucide-react";

export interface SortableColumnRowProps {
  id: string;
  label: string;
  onRemove: () => void;
  sortDirection?: "asc" | "desc" | false;
  onToggleSort?: () => void;
}

export const SortableColumnRow = ({ id, label, onRemove, sortDirection, onToggleSort }: SortableColumnRowProps) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className="flex items-center gap-2 rounded-md border bg-background px-2 py-1.5"
      data-testid={`sortable-column-row-${id}`}
    >
      <button
        className="cursor-grab touch-none text-muted-foreground hover:text-foreground focus:outline-none"
        data-testid={`drag-handle-${id}`}
        {...attributes}
        {...listeners}
      >
        <GripVertical className="h-4 w-4" />
      </button>
      <span className="flex-1 text-sm font-normal">{label}</span>
      {onToggleSort && (
        <button
          className="text-muted-foreground hover:text-foreground focus:outline-none"
          onClick={onToggleSort}
          aria-label={`Sort by ${label}`}
          data-testid={`sort-toggle-${id}`}
        >
          {sortDirection === "asc" ? (
            <ArrowDown className="h-4 w-4" />
          ) : sortDirection === "desc" ? (
            <ArrowUp className="h-4 w-4" />
          ) : (
            <ArrowUpDown className="h-4 w-4 opacity-40" />
          )}
        </button>
      )}
      <button
        className="text-muted-foreground hover:text-foreground focus:outline-none"
        onClick={onRemove}
        aria-label={`Remove ${label}`}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
};
